import { history } from "common/history";
import AuthSplash from "components/redesign/AuthSplash";
import React from "react";
import { Redirect, Route } from "react-router-dom";

const ProtectedRoute = ({
  component: Component,
  isAuthenticated,
  isVerifying,
  ...rest
}) => {
  localStorage.setItem("redirectUri", history.location.pathname);
  return (
    <Route
      {...rest}
      render={(props) =>
        isVerifying ? (
          <AuthSplash />
        ) : isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
export default ProtectedRoute;
